import { DateDefault, FilterOperator } from '@vendasta/crm';
import { GalaxyFilterOperator } from '@vendasta/galaxy/filter/chips';

export const FIELD_ID_URL_PARAM = 'fieldId';
export const OBJECT_TYPE_URL_PARAM = 'objectType';

export const UnaryOperators: FilterOperator[] = [
  FilterOperator.FILTER_OPERATOR_INVALID,
  FilterOperator.FILTER_OPERATOR_IS_EMPTY,
  FilterOperator.FILTER_OPERATOR_IS_NOT_EMPTY,
];

export const UnaryGalaxyOperators: GalaxyFilterOperator[] = [
  GalaxyFilterOperator.FILTER_OPERATOR_INVALID,
  GalaxyFilterOperator.FILTER_OPERATOR_IS_EMPTY,
  GalaxyFilterOperator.FILTER_OPERATOR_IS_NOT_EMPTY,
];

export const RangeValueOperators: FilterOperator[] = [
  FilterOperator.FILTER_OPERATOR_IS_BETWEEN,
  FilterOperator.FILTER_OPERATOR_IS_NOT_BETWEEN,
];

export const FilterOperatorToLabel: Record<FilterOperator, string> = {
  [FilterOperator.FILTER_OPERATOR_INVALID]: 'GALAXY.FILTER.CHIP.OPERATOR.INVALID',
  [FilterOperator.FILTER_OPERATOR_IS_EMPTY]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_EMPTY',
  [FilterOperator.FILTER_OPERATOR_IS_NOT_EMPTY]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_NOT_EMPTY',
  [FilterOperator.FILTER_OPERATOR_IS]: 'GALAXY.FILTER.CHIP.OPERATOR.IS',
  [FilterOperator.FILTER_OPERATOR_IS_NOT]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_NOT',
  [FilterOperator.FILTER_OPERATOR_IS_ANY]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_ANY',
  [FilterOperator.FILTER_OPERATOR_IS_NOT_ANY]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_NOT_ANY',
  [FilterOperator.FILTER_OPERATOR_IS_ALL]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_ALL',
  [FilterOperator.FILTER_OPERATOR_IS_NOT_ALL]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_NOT_ALL',
  [FilterOperator.FILTER_OPERATOR_CONTAINS]: 'GALAXY.FILTER.CHIP.OPERATOR.CONTAINS',
  [FilterOperator.FILTER_OPERATOR_DOES_NOT_CONTAIN]: 'GALAXY.FILTER.CHIP.OPERATOR.DOES_NOT_CONTAIN',
  [FilterOperator.FILTER_OPERATOR_IS_EQUAL_TO]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_EQUAL_TO',
  [FilterOperator.FILTER_OPERATOR_IS_NOT_EQUAL_TO]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_NOT_EQUAL_TO',
  [FilterOperator.FILTER_OPERATOR_IS_GREATER_THAN]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_GREATER_THAN',
  [FilterOperator.FILTER_OPERATOR_IS_GREATER_THAN_OR_EQUAL_TO]:
    'GALAXY.FILTER.CHIP.OPERATOR.IS_GREATER_THAN_OR_EQUAL_TO',
  [FilterOperator.FILTER_OPERATOR_IS_LESS_THAN]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_LESS_THAN',
  [FilterOperator.FILTER_OPERATOR_IS_LESS_THAN_OR_EQUAL_TO]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_LESS_THAN_OR_EQUAL_TO',
  [FilterOperator.FILTER_OPERATOR_IS_BEFORE]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_BEFORE',
  [FilterOperator.FILTER_OPERATOR_IS_BEFORE_OR_ON]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_BEFORE_OR_ON',
  [FilterOperator.FILTER_OPERATOR_IS_AFTER]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_AFTER',
  [FilterOperator.FILTER_OPERATOR_IS_AFTER_OR_ON]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_AFTER_OR_ON',
  [FilterOperator.FILTER_OPERATOR_IS_BETWEEN]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_BETWEEN',
  [FilterOperator.FILTER_OPERATOR_IS_NOT_BETWEEN]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_NOT_BETWEEN',
  [FilterOperator.FILTER_OPERATOR_IS_VALID]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_VALID',
  [FilterOperator.FILTER_OPERATOR_IS_NOT_VALID]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_NOT_VALID',
  [FilterOperator.FILTER_OPERATOR_ANNIVERSARY_IS]: 'GALAXY.FILTER.CHIP.OPERATOR.ANNIVERSARY_IS',
};

export const DateDefaultToLabel: Record<DateDefault, string> = {
  [DateDefault.DATE_DEFAULT_INVALID]: 'LIST_OBJECTS_TABLE.DATE_DEFAULT.INVALID',
  [DateDefault.DATE_DEFAULT_TODAY]: 'LIST_OBJECTS_TABLE.DATE_DEFAULT.TODAY',
  [DateDefault.DATE_DEFAULT_YESTERDAY]: 'LIST_OBJECTS_TABLE.DATE_DEFAULT.YESTERDAY',
  [DateDefault.DATE_DEFAULT_TOMORROW]: 'LIST_OBJECTS_TABLE.DATE_DEFAULT.TOMORROW',
  [DateDefault.DATE_DEFAULT_THIS_WEEK]: 'LIST_OBJECTS_TABLE.DATE_DEFAULT.THIS_WEEK',
  [DateDefault.DATE_DEFAULT_LAST_WEEK]: 'LIST_OBJECTS_TABLE.DATE_DEFAULT.LAST_WEEK',
  [DateDefault.DATE_DEFAULT_NEXT_WEEK]: 'LIST_OBJECTS_TABLE.DATE_DEFAULT.NEXT_WEEK',
  [DateDefault.DATE_DEFAULT_THIS_MONTH]: 'LIST_OBJECTS_TABLE.DATE_DEFAULT.THIS_MONTH',
  [DateDefault.DATE_DEFAULT_LAST_MONTH]: 'LIST_OBJECTS_TABLE.DATE_DEFAULT.LAST_MONTH',
  [DateDefault.DATE_DEFAULT_NEXT_MONTH]: 'LIST_OBJECTS_TABLE.DATE_DEFAULT.NEXT_MONTH',
  [DateDefault.DATE_DEFAULT_THIS_QUARTER]: 'LIST_OBJECTS_TABLE.DATE_DEFAULT.THIS_QUARTER',
  [DateDefault.DATE_DEFAULT_LAST_QUARTER]: 'LIST_OBJECTS_TABLE.DATE_DEFAULT.LAST_QUARTER',
  [DateDefault.DATE_DEFAULT_NEXT_QUARTER]: 'LIST_OBJECTS_TABLE.DATE_DEFAULT.NEXT_QUARTER',
  [DateDefault.DATE_DEFAULT_THIS_YEAR]: 'LIST_OBJECTS_TABLE.DATE_DEFAULT.THIS_YEAR',
  [DateDefault.DATE_DEFAULT_LAST_YEAR]: 'LIST_OBJECTS_TABLE.DATE_DEFAULT.LAST_YEAR',
  [DateDefault.DATE_DEFAULT_NEXT_YEAR]: 'LIST_OBJECTS_TABLE.DATE_DEFAULT.NEXT_YEAR',
};

export const DYNAMIC_LISTS_PAGE_ROUTES = {
  LIST: 'list',
  CREATE: 'create',
  EDIT: 'edit/:id',
};
